/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { SscrSiteAssignmentSummaryDto } from './sscrSiteAssignmentSummaryDto.schema';

export const IReadOnlyListOfSscrSiteAssignmentSummaryDto = zod.array(zod.lazy(() => SscrSiteAssignmentSummaryDto));

export type IReadOnlyListOfSscrSiteAssignmentSummaryDto = zod.input<typeof IReadOnlyListOfSscrSiteAssignmentSummaryDto>;
export type IReadOnlyListOfSscrSiteAssignmentSummaryDtoOutput = zod.output<typeof IReadOnlyListOfSscrSiteAssignmentSummaryDto>;
